import React, { useState, useEffect, useRef, useCallback } from "react";
import { db, storage, admin } from "../../firebase";
import "./MatchPlayTournaments.css";
import { useAuth } from "../../contexts/AuthContext";
import Dropdown from "react-dropdown";
import "react-dropdown/style.css";
// Components
import CoursePicker from "../../components/Events/CoursePicker/CoursePicker";
import BackdropLoader from "../../components/Loaders/BackdropLoader";
import ImageSelector from "../../components/Events/ImageSelector/ImageSelector";
import PlayerItem from "../../components/display/PlayerItem/PlayerItem";
import { useDropzone } from "react-dropzone";
import Switch from "react-ios-switch/lib/Switch";
import Compressor from "compressorjs";
// Mui
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Dialog,
  LinearProgress,
  Snackbar,
  Tab,
  Tabs,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import InfoIcon from "@mui/icons-material/Info";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import ArrowBack from "@mui/icons-material/ArrowBack";

import { Country, City, State } from "country-state-city";
import PageHeader from "../../components/display/Rows/PageHeader";

// Gradient Icons
const GradientInfoIcon = ({ onClick, className }) => (
  <>
    <svg width={0} height={0}>
      <linearGradient id="linearColors" x1={1} y1={0} x2={1} y2={1}>
        <stop offset={0} stopColor="#21c17c" />
        <stop offset={5} stopColor="#1e7a69" />
      </linearGradient>
    </svg>
    <InfoIcon
      onClick={onClick}
      className={`dg-icon-bg ${className}`}
      sx={{ fill: "url(#linearColors)" }}
    />
  </>
);

const GradientRemoveCircleIcon = ({ onClick }) => (
  <>
    <svg width={0} height={0}>
      <linearGradient id="linearColorss" x1={1} y1={0} x2={1} y2={1}>
        <stop offset={0} stopColor="#F0A4AA" />
        <stop offset={5} stopColor="#70242A" />
      </linearGradient>
    </svg>
    <RemoveCircleIcon
      onClick={onClick}
      className="red-icon"
      sx={{ fill: "url(#linearColorss)" }}
    />
  </>
);

// Options
const fixtureOptions = [
  {
    label: "Manual",
    value: "manual",
  },
  {
    label: "Generated",
    value: "generated",
  },
];
const pointsOptions = [
  {
    label: "Normal",
    value: "normal",
  },
  {
    label: "Holes Won",
    value: "holes",
  },
];
const teamOptions = [
  {
    label: "Singles",
    value: "singles",
  },
  {
    label: "Doubles",
    value: "doubles",
  },
];
const roundOptions = [
  {
    label: "1",
    value: "1",
  },
  {
    label: "2",
    value: "2",
  },
  {
    label: "3",
    value: "3",
  },
  {
    label: "4",
    value: "4",
  },
];
const progressOptions = [
  {
    label: "1",
    value: "1",
  },
  {
    label: "2",
    value: "2",
  },
];
const sizeOptions = [
  {
    label: "3",
    value: "3",
  },
  {
    label: "4",
    value: "4",
  },
  {
    label: "5",
    value: "5",
  },
  {
    label: "6",
    value: "6",
  },
];
const publicOptions = [
  {
    label: "Public",
    value: "public",
  },
  {
    label: "Private",
    value: "private",
  },
];
const tournamentTypes = [
  {
    label: "Knockout",
    value: "knockout",
  },
  {
    label: "Round Robin",
    value: "robin",
  },
  {
    label: "Tournament",
    value: "tournament",
  },
];

function MatchPlayTournamentEditor({
  tournID = "",
  goBack = () => {},
  edit = false,
  reload = () => {},
  defaultClubID = "",
  defaultCourseData = "",
}) {
  const { currentUser, userDetails } = useAuth();

  // Various
  const [loading, setLoading] = useState(true);
  const [showDialog, setShowDialog] = useState(false);
  const [generalOpen, setGeneralOpen] = useState(false);
  const [adminOpen, setAdminOpen] = useState(false);
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [dialog, setDialog] = useState("");
  const [error, setError] = useState("");
  const [showSnack, setShowSnack] = useState(false);
  const [showImageSelector, setShowImageSelector] = useState(false);
  const [image, setImage] = useState("");
  const [adminOptions, setAdminOptions] = useState([]);
  const [imgageURL, setImageURL] = useState("");
  const [update, setUpdate] = useState(0);

  // Variables
  const [clubID, setClubID] = useState("");
  const [clubOptions, setClubOptions] = useState([]);

  const [playerType, setPlayerType] = useState("singles");

  const [tournamentName, setTournamentName] = useState("");
  const [description, setDescription] = useState("");
  const [started, setStarted] = useState(false);
  const [invited, setInvited] = useState([]);
  const [inviteable, setInviteable] = useState([]);
  const [members, setMembers] = useState([]);
  const [selectedPlayers, setSelectedPlayers] = useState([]);
  const [rounds, setRounds] = useState(1);
  const [players, setPlayers] = useState([]);
  const [teamType, setTeamType] = useState("singles");
  const [tournamentType, setTournamentType] = useState("knockout");
  const [type, setType] = useState("public");
  const [groupSize, setGroupSize] = useState("4");
  const [joinCode, setJoinCode] = useState("");
  const [imageLink, setImageLink] = useState("");
  const [admins, setAdmins] = useState([currentUser.uid]);
  const [fixtures, setFixtures] = useState("manual");
  const [inviteOnly, setInviteOnly] = useState(false);
  const [pointsType, setPointsType] = useState("normal");
  const [progression, setProgression] = useState("2");
  const [selTab, setSelTab] = useState("general");

  const [countries, setCountries] = useState([]);
  const [cities, setCities] = useState([]);
  const [states, setStates] = useState([]);

  const [selCountry, setSelCountry] = useState("");
  const [selCity, setSelCity] = useState("");
  const [selState, setSelState] = useState("");

  const [chosen, setChosen] = useState(true);
  const [selectedCourse, setSelectedCourse] = useState({
    value: "",
    label: "",
  });

  const playerOptions = [
    {
      label: "Singles",
      value: "singles",
    },
    {
      label: "Doubles",
      value: "doubles",
    },
  ];

  // Refs
  const nameRef = useRef();
  const picScrollRef = useRef();
  const cityRef = useRef();
  const countryRef = useRef();
  const stateRef = useRef();

  const onDrop = useCallback((acceptedFiles) => {
    // Do something with the files
    console.log(acceptedFiles[0]);
    new Compressor(acceptedFiles[0], {
      convertSize: 1000000,
      success: (res) => {
        console.log(res);
        setImage(res);
      },
    });
    const url = URL.createObjectURL(acceptedFiles[0]);
    setImageURL(url);
  }, []);
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  useEffect(() => {
    if (edit) {
      loadDetails();
    } else {
      if (defaultCourseData !== "") {
        setSelectedCourse({
          value: defaultCourseData.courseID,
          label: defaultCourseData.name,
        });
      }
    }
  }, []);

  useEffect(() => {
    if (currentUser) {
      loadClubOptions();
    }

    if (currentUser && userDetails && !edit) {
      loadUserFriends({ members: [], invited: [] });
    }
    if (!edit) {
      sortLocation({
        defaultCity: userDetails.city,
        defaultCountry: userDetails.country,
        defaultState: userDetails.state,
      });
    }
  }, [currentUser, userDetails]);

  async function loadUserFriends({ members = [], invited = [] }) {
    const friends = userDetails.friends;
    for (let i = 0; i < members.length; i++) {
      if (!friends.includes(members[i])) {
        friends.push(members[i]);
      }
    }
    for (let i = 0; i < invited.length; i++) {
      if (!friends.includes(invited[i])) {
        friends.push(invited[i]);
      }
    }
    const friendRefs = friends.map((playerID) =>
      db.collection("users").doc(playerID).get()
    );

    const arr = [];
    const memberArr = [];
    const inviteArr = [];
    const inviteableArr = [];

    Promise.all(friendRefs).then((docs) => {
      for (let i = 0; i < docs.length; i++) {
        const playerDoc = docs[i];
        const playerID = playerDoc.id;
        const player = playerDoc.data();
        if (!playerDoc.exists) {
          continue;
        }
        const { firstName, lastName, handicap, profileImage } = player;
        arr.push({
          name: `${firstName} ${lastName}`,
          label: `${firstName} ${lastName}`,
          value: playerID,
          handicap,
          playerID,
          profileImage,
        });
        if (members.includes(playerID)) {
          memberArr.push({
            name: `${firstName} ${lastName}`,
            label: `${firstName} ${lastName}`,
            value: playerID,
            handicap,
            playerID,
            profileImage,
          });
        } else if (invited.includes(playerID)) {
          inviteArr.push({
            name: `${firstName} ${lastName}`,
            label: `${firstName} ${lastName}`,
            value: playerID,
            handicap,
            playerID,
            profileImage,
          });
        } else {
          inviteableArr.push({
            name: `${firstName} ${lastName}`,
            label: `${firstName} ${lastName}`,
            value: playerID,
            handicap,
            playerID,
            profileImage,
          });
        }
      }
      setSelectedPlayers(inviteArr);
      setInvited(inviteArr);
      setMembers(memberArr);
      setInviteable(inviteableArr);
      setPlayers(arr);
      // console.log(arr);
      setLoading(false);
    });
  }

  async function loadDetails() {
    const tournamentDoc = await db.collection("tournaments").doc(tournID).get();
    const tournament = tournamentDoc.data();
    loadUserFriends({
      members: tournament.playerIDs,
      invited: tournament.invitedIDs,
    });
    setSelectedCourse({
      value: tournament.courseID ?? "",
      label: tournament.courseName ?? "",
    });
    setPlayerType(tournament.playerType ?? "singles");
    setImageURL(tournament.imageLink);
    setStarted(tournament.started ?? false);
    setTournamentName(tournament.tournamentName);
    setInviteOnly(tournament.inviteOnly ?? false);
    setTournamentType(tournament.tournamentType);
    setFixtures(tournament.fixtures);
    setDescription(tournament.description);
    setJoinCode(tournament.joinCode);
    setType(tournament.type);
    setTeamType(tournament.teamType);
    setGroupSize(tournament.groupSize);
    setImageLink(tournament.imageLink);
    setRounds(tournament.rounds ?? "1");
    setClubID(tournament.clubID ?? "");
    sortLocation({
      defaultCity: tournament.city,
      defaultCountry: tournament.country,
      defaultState: tournament.state,
    });
  }

  function sortLocation({ defaultCity, defaultCountry, defaultState }) {
    const userCity = edit ? defaultCity : userDetails.city;
    const userCountry = edit ? defaultCountry : userDetails.country;
    const userState = edit ? defaultState : userDetails.state;
    // console.log(userCity, userCountry, userState);
    let stateCode = "";

    // Country
    const allCunts = Country.getAllCountries().map((country) => {
      const item = {
        name: country.name,
        value: country.name,
        code: country.isoCode,
      };
      return item;
    });
    setCountries(allCunts);
    setSelCountry(userCountry);

    // State
    const allStates = State.getStatesOfCountry(userCountry);
    setStates(allStates);
    setSelState(userState);

    for (let i = 0; i < allStates.length; i++) {
      if (allStates[i].name === userState) {
        stateCode = allStates[i].isoCode;
      }
    }

    // City
    const cities = City.getCitiesOfState(userCountry, stateCode);
    // console.log(cities);
    setCities(cities);
    setSelCity(userCity);
  }

  function validate() {
    // Name
    if (tournamentName === "") {
      setError("Please select a tournament name");
      return false;
    }
    // Course
    if (selectedCourse.value === "") {
      setError("Please select a course");
      return false;
    }
    return true;
  }

  function loadStates(cunt) {
    const states = State.getStatesOfCountry(cunt);
    const countryDeets = Country.getCountryByCode(cunt);
    setSelCountry(countryDeets.name);
    setStates(states);
  }

  async function loadCities(state, count = "") {
    // console.log(selCountry);
    let toUse = selCountry;
    if (count !== "") {
      toUse = count;
    }
    // console.log(toUse);
    const test = State.getStatesOfCountry(toUse);
    // console.log(test.length);
    let sc = "";
    let cc = "";
    for (let i = 0; i < test.length; i++) {
      if (test[i].name === state) {
        sc = test[i].isoCode;
        cc = test[i].countryCode;
      }
    }
    console.log(sc, cc);
    const cities = City.getCitiesOfState(cc, sc);

    const newArr = cities.map((city) => {
      const item = {
        name: city.name,
        value: city.name,
      };
      return item;
    });
    console.log(selState);
    console.log(states);
    // setSelState(sc);

    setUpdate((current) => current + 1);
    setCities(newArr);
  }

  async function saveTournament() {
    // return console.log(selCountry, selCity, selState);

    setLoading(true);
    if (!validate()) {
      return setLoading(false);
    }

    const invitedIDs = selectedPlayers.map((player) => player.playerID);

    const tournDoc = await db.collection("tournaments").add({
      tournamentName,
      started: false,
      invitedIDs,
      clubID,
      playerIDs: [],
      courseID: selectedCourse.value ?? selectedCourse.courseID,
      courseName: selectedCourse.label ?? selectedCourse.name,
      // playerIDs: [currentUser.uid],
      roundIDs: [],
      results: [],
      country: selCountry,
      city: selCity,
      state: selState,
      tournamentType,
      groupSize,
      joinCode,
      admins: [currentUser.uid],
      fixtures,
      inviteOnly,
      progression,
      playerType,
      type,
      rounds,
      pointsType,
      dateCreated: new Date(),
      completed: false,
      table: [],
      stage: "groups",
      groups: [],
      teams: [],
    });
    if (image !== "") {
      if (typeof image === "string") {
        fetch(image).then(async (response) => {
          const contentType = response.headers.get("content-type");
          const blob = await response.blob();
          const file = new File([blob], "tournImage.jpg", { contentType });
          // access file here
          const task = storage
            .ref()
            .child(`${tournDoc.id}/${image.name}`)
            .put(file);
          await task.then(async (snapshot) => {
            await snapshot.ref.getDownloadURL().then((url) => {
              db.collection("tournaments").doc(tournDoc.id).update({
                imageLink: url,
              });
              setLoading(false);
              reload();
              goBack();
            });
          });
        });
      } else {
        const task = storage
          .ref()
          .child(`${tournDoc.id}/${image.name}`)
          .put(image);
        await task.then(async (snapshot) => {
          await snapshot.ref.getDownloadURL().then((url) => {
            db.collection("tournaments").doc(tournDoc.id).update({
              imageLink: url,
            });
            setLoading(false);
            reload();
            goBack();
          });
        });
      }
    } else {
      setLoading(false);
      reload();
      goBack();
    }
  }

  async function saveChanges() {
    // return console.log(typeof image);
    setLoading(true);
    if (!validate()) {
      return setLoading(false);
    }

    const invitedIDs = selectedPlayers.map((player) => player.playerID);
    console.log(selectedCourse);
    await db
      .collection("tournaments")
      .doc(tournID)
      .update({
        tournamentName,
        invitedIDs,
        courseID: selectedCourse.value ?? selectedCourse.courseID,
        courseName: selectedCourse.label ?? selectedCourse.name,
        country: selCountry,
        city: selCity,
        state: selState,
        tournamentType,
        groupSize,
        joinCode,
        inviteOnly,
        admins,
        fixtures,
        type,
        rounds,
        progression,
        playerType,
        clubID,
      });
    if (image !== "") {
      if (typeof image === "string") {
        fetch(image).then(async (response) => {
          const contentType = response.headers.get("content-type");
          const blob = await response.blob();
          const file = new File([blob], "tournImage.jpg", { contentType });
          // access file here
          const task = storage
            .ref()
            .child(`${tournID}/${image.name}`)
            .put(file);
          await task.then(async (snapshot) => {
            await snapshot.ref.getDownloadURL().then((url) => {
              db.collection("tournaments").doc(tournID).update({
                imageLink: url,
              });
            });
          });
        });
      } else {
        const task = storage
          .ref()
          .child(`${tournID}/${image.name ?? "img"}`)
          .put(image);
        await task.then(async (snapshot) => {
          await snapshot.ref.getDownloadURL().then((url) => {
            db.collection("tournaments").doc(tournID).update({
              imageLink: url,
            });
          });
        });
      }
    }

    setLoading(false);
    reload();
    goBack();
  }

  function selectAll() {
    setSelectedPlayers((current) => [...current, ...players]);
    setPlayers([]);
  }

  function makeID() {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < 12; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    console.log(result);
    return setJoinCode(result);
  }

  async function loadClubOptions() {
    const clubDocs = await db
      .collection("clubs")
      .where("adminIDs", "array-contains", currentUser.uid)
      .get();
    const clubArr = [];

    console.log(clubDocs.docs.length);

    for (let i = 0; i < clubDocs.docs.length; i++) {
      const clubDoc = clubDocs.docs[i];
      const clubID = clubDoc.id;
      const club = clubDoc.data();
      const { clubName } = club;
      clubArr.push({
        clubName,
        clubID,
        value: clubID,
        label: clubName,
      });
    }
    setClubOptions(clubArr);
    if (!edit) {
      if (defaultClubID) {
        setClubID(defaultClubID);
      }
    }
  }

  return (
    <div className="mpl-editor league-creator event-creator onboarding">
      <Snackbar
        open={showSnack}
        autoHideDuration={6000}
        onClose={() => setShowSnack(false)}
        message="Copied to clipboard"
      />
      <Dialog open={showDialog} onClose={() => setShowDialog(false)}>
        <div className="info-message">
          <GradientInfoIcon className="big-info-icon" />
          <p>{dialog}</p>
        </div>
      </Dialog>
      {loading && <BackdropLoader />}
      {showImageSelector ? (
        <ImageSelector
          goBack={() => {
            setShowImageSelector(false);
            setTimeout(
              () => picScrollRef.current.scrollIntoView({ behavior: "smooth" }),
              100
            );
          }}
          setSelectedImage={(e) => {
            setImageURL(e);
            setImage(e);
          }}
          selectedImage={image}
          type="league"
        />
      ) : !chosen ? (
        <CoursePicker
          goBack={() => {
            setChosen(true);
          }}
          setChosen={setChosen}
          setCourseDetails={(e) => {
            setSelectedCourse(e);
          }}
        />
      ) : (
        <>
          <div className="back-row" onClick={() => goBack()}>
            <ArrowBack />
            <p>Back</p>
          </div>

          <PageHeader
            text={
              edit
                ? "Matchplay Tournament Editor"
                : "Matchplay Tournament Creator"
            }
          />
          <div className="ec-tabs">
            <Tabs value={selTab} onChange={(e, value) => setSelTab(value)}>
              <Tab label="General" value="general" />
              <Tab label="Details" value="details" />
              <Tab label="Admin" value="admin" />
            </Tabs>
          </div>
          {selTab === "general" && (
            <>
              <div className="pl-20 mt-20">
                <h2 className="ne-header">General</h2>
              </div>

              <div className="ec-box mb-40" style={{ alignItems: "flex-end" }}>
                <div className="input-group">
                  <p>Tournament Name</p>
                  <input
                    placeholder="Enter tournament name..."
                    ref={nameRef}
                    type={"text"}
                    defaultValue={tournamentName}
                    onChange={(e) => setTournamentName(e.target.value)}
                  />
                </div>
                {false && clubOptions.length > 0 && (
                  <div className="input-group league-hint ">
                    <div className="ig-header">
                      <p>Club</p>
                    </div>

                    <Dropdown
                      arrowClosed={
                        <KeyboardArrowDownIcon className="drop-icon" />
                      }
                      arrowOpen={<KeyboardArrowUpIcon className="drop-icon" />}
                      options={clubOptions}
                      value={clubID}
                      onChange={(e) => {
                        console.log(e.value);
                        setClubID(e.value);
                      }}
                    />
                  </div>
                )}
                <div className="input-group">
                  <div className="ig-header">
                    <p>Home Course</p>
                    {/* {!disableChanges && ( */}
                    <EditIcon
                      className="dg-icon-bg icon-cursor ml-20"
                      onClick={() => {
                        // if (!disableChanges) {
                        setChosen(false);
                        // }
                      }}
                    />
                    {/* )} */}
                  </div>

                  <div>
                    <input
                      disabled
                      placeholder="No course selected"
                      value={selectedCourse.label ?? selectedCourse.name}
                    />
                  </div>
                </div>

                {!started && (
                  <div className="input-group pp-hint mt-20">
                    <div className="ig-header">
                      <p>Participation Type</p>

                      <GradientInfoIcon
                        className="info-icon"
                        onClick={() => {
                          setDialog(
                            "Select whether players enter as singles or teams of two players"
                          );
                          setShowDialog(true);
                        }}
                      />
                    </div>
                    <Dropdown
                      arrowClosed={
                        <KeyboardArrowDownIcon className="drop-icon" />
                      }
                      arrowOpen={<KeyboardArrowUpIcon className="drop-icon" />}
                      value={playerType}
                      options={playerOptions}
                      onChange={(e) => {
                        setPlayerType(e.value);
                      }}
                    />
                  </div>
                )}
                {!started && (
                  <div className="input-group pp-hint">
                    <div className="ig-header">
                      <p>Tournament Type</p>

                      <GradientInfoIcon
                        className="info-icon"
                        onClick={() => {
                          setDialog("");
                          setShowDialog(true);
                        }}
                      />
                    </div>
                    <Dropdown
                      arrowClosed={
                        <KeyboardArrowDownIcon className="drop-icon" />
                      }
                      arrowOpen={<KeyboardArrowUpIcon className="drop-icon" />}
                      value={tournamentType}
                      options={tournamentTypes}
                      onChange={(e) => {
                        setTournamentType(e.value);
                      }}
                    />
                  </div>
                )}
                {tournamentType === "tournament" && !started && (
                  <div className="input-group pp-hint mt-0">
                    <div className="ig-header">
                      <p>Group Size</p>
                      <GradientInfoIcon
                        className="info-icon"
                        onClick={() => {
                          setDialog(
                            "Choose how many players will be in each group in the group stages"
                          );
                          setShowDialog(true);
                        }}
                      />
                    </div>
                    <Dropdown
                      disabled={started}
                      arrowClosed={
                        <KeyboardArrowDownIcon className="drop-icon" />
                      }
                      arrowOpen={<KeyboardArrowUpIcon className="drop-icon" />}
                      value={groupSize}
                      options={sizeOptions}
                      onChange={(e) => {
                        setGroupSize(e.value);
                      }}
                    />
                  </div>
                )}
                {tournamentType === "tournament" && !started && (
                  <div className="input-group pp-hint">
                    <div className="ig-header">
                      <p>Progression</p>
                      <GradientInfoIcon
                        className="info-icon"
                        onClick={() => {
                          setDialog(
                            "Choose how many players progress to the knockout phase"
                          );
                          setShowDialog(true);
                        }}
                      />
                    </div>
                    <Dropdown
                      disabled={started}
                      arrowClosed={
                        <KeyboardArrowDownIcon className="drop-icon" />
                      }
                      arrowOpen={<KeyboardArrowUpIcon className="drop-icon" />}
                      value={progression}
                      options={progressOptions}
                      onChange={(e) => {
                        setProgression(e.value);
                      }}
                    />
                  </div>
                )}
                {tournamentType === "robin" && false && (
                  <div className="input-group pp-hint mt-0">
                    <div className="ig-header">
                      <p>Rounds</p>
                      <GradientInfoIcon
                        className="info-icon"
                        onClick={() => {
                          setDialog(
                            "Choose how many times players will face each other"
                          );
                          setShowDialog(true);
                        }}
                      />
                    </div>
                    <Dropdown
                      arrowClosed={
                        <KeyboardArrowDownIcon className="drop-icon" />
                      }
                      arrowOpen={<KeyboardArrowUpIcon className="drop-icon" />}
                      value={rounds}
                      options={roundOptions}
                      onChange={(e) => {
                        setRounds(e.value);
                      }}
                    />
                  </div>
                )}
                {tournamentType === "knockout mt-0" && (
                  <div className="input-group pp-hint">
                    <div className="ig-header">
                      <p>Fixtures</p>
                      <GradientInfoIcon
                        className="info-icon"
                        onClick={() => {
                          setDialog(
                            "Choose whether fixtures should be auto-generated or manually set up"
                          );
                          setShowDialog(true);
                        }}
                      />
                    </div>
                    <Dropdown
                      arrowClosed={
                        <KeyboardArrowDownIcon className="drop-icon" />
                      }
                      arrowOpen={<KeyboardArrowUpIcon className="drop-icon" />}
                      value={fixtures}
                      disabled={started}
                      options={fixtureOptions}
                      onChange={(e) => {
                        setFixtures(e.value);
                      }}
                    />
                  </div>
                )}
                {tournamentType !== "knockout" && (
                  <div className="input-group pp-hint">
                    <div className="ig-header">
                      <p>Points</p>
                      <GradientInfoIcon
                        className="info-icon"
                        onClick={() => {
                          setDialog(
                            "Normal points system awards 10 points to the winner of a match, and 5 to each player if the match is tied. The holes points system awards 5 points per holes led at the end of the match (e.g. winning 3&1 earns you 15 points)"
                          );
                          setShowDialog(true);
                        }}
                      />
                    </div>
                    <Dropdown
                      arrowClosed={
                        <KeyboardArrowDownIcon className="drop-icon" />
                      }
                      arrowOpen={<KeyboardArrowUpIcon className="drop-icon" />}
                      value={pointsType}
                      options={pointsOptions}
                      disabled={started}
                      onChange={(e) => {
                        setPointsType(e.value);
                      }}
                    />
                  </div>
                )}
                {tournamentType === "tournament" && (
                  <div className="input-group pp-hint">
                    <div className="ig-header">
                      <p>Groups</p>
                      <GradientInfoIcon
                        className="info-icon"
                        onClick={() => {
                          setDialog(
                            "Choose whether groups should be auto-generated or manually set up"
                          );
                          setShowDialog(true);
                        }}
                      />
                    </div>
                    <Dropdown
                      arrowClosed={
                        <KeyboardArrowDownIcon className="drop-icon" />
                      }
                      arrowOpen={<KeyboardArrowUpIcon className="drop-icon" />}
                      value={fixtures}
                      disabled={started}
                      options={fixtureOptions}
                      onChange={(e) => {
                        setFixtures(e.value);
                      }}
                    />
                  </div>
                )}

                {false && (
                  <div className="input-group pp-hint mb-20">
                    <div className="ig-header">
                      <p>Participation</p>

                      <GradientInfoIcon
                        className="info-icon"
                        onClick={() => {
                          setDialog(
                            "Choose whether players will play by themselves, or pair up in teams of 2"
                          );
                          setShowDialog(true);
                        }}
                      />
                    </div>
                    <Dropdown
                      arrowClosed={
                        <KeyboardArrowDownIcon className="drop-icon" />
                      }
                      arrowOpen={<KeyboardArrowUpIcon className="drop-icon" />}
                      value={teamType}
                      options={teamOptions}
                      onChange={(e) => {
                        setTeamType(e.value);
                      }}
                    />
                  </div>
                )}
              </div>
            </>
          )}
          {selTab === "details" && (
            <>
              <div className="pl-20 mt-20">
                <h2 className="ne-header">Details</h2>
              </div>
              <div className="ec-box">
                <div className="input-group select-group">
                  <p>Country</p>
                  <select
                    defaultValue={selCountry}
                    ref={countryRef}
                    onChange={(e) => {
                      loadStates(countryRef.current.value);
                      setSelCountry(countryRef.current.value);
                    }}
                  >
                    <option value=""></option>
                    {countries.map((country) => {
                      return (
                        <option
                          key={country.code}
                          selected={country.code === selCountry}
                          value={country.code}
                        >
                          {country.name}
                        </option>
                      );
                    })}
                  </select>
                </div>

                <div className="input-group select-group">
                  <p>State / Province</p>
                  <select
                    defaultValue={selState}
                    disabled={selCountry === ""}
                    ref={stateRef}
                    onChange={(e) => {
                      setSelState(stateRef.current.value);
                      loadCities(stateRef.current.value);
                    }}
                  >
                    <option value=""></option>

                    {states.map((state) => {
                      return (
                        <option
                          key={state.code}
                          selected={state.name === selState}
                          value={state.code}
                        >
                          {state.name}
                        </option>
                      );
                    })}
                  </select>
                </div>

                <div className="input-group select-group">
                  <p>City</p>
                  <select
                    defaultValue={selCity}
                    disabled={selState === ""}
                    ref={cityRef}
                    onChange={(e) => {
                      setSelCity(cityRef.current.value);
                    }}
                  >
                    <option value=""></option>

                    {cities.map((city) => {
                      return (
                        <option
                          key={city.name}
                          selected={city.name === selCity}
                          value={city.name}
                        >
                          {city.name}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div className="input-group">
                  <div className="ig-header">
                    <p>Description</p>
                    <GradientInfoIcon
                      className="info-icon"
                      onClick={() => {
                        setDialog([
                          "Browsers can be a bit funny with lines - please type /n to start a new paragraph.",
                        ]);
                        setShowDialog(true);
                      }}
                    />
                  </div>{" "}
                  <textarea
                    placeholder="Enter tournament description..."
                    defaultValue={description}
                    rows={6}
                    onChange={(e) => setDescription(e.target.value)}
                  />
                </div>
                <div ref={picScrollRef} className="input-group mb-20">
                  <p>Tournament Picture</p>
                  <div className="image-buttons">
                    <div {...getRootProps()}>
                      <input {...getInputProps()} />
                      {/* <div className="image-selectorr ec-is"> */}
                      <button className="green-link mb-20">Upload</button>
                      {/* </div> */}
                    </div>

                    {/* <div className="ec-is" style={{ marginLeft: "0px" }}> */}
                    <button
                      className="green-link"
                      onClick={() => setShowImageSelector(true)}
                    >
                      Choose
                    </button>
                    {/* </div> */}
                  </div>
                  {imgageURL !== "" && (
                    <div className="event-img">
                      <img className="" alt="profile" src={imgageURL} />
                    </div>
                  )}
                </div>
              </div>
            </>
          )}
          {selTab === "admin" && (
            <>
              <div className="pl-20 mt-20">
                <h2 className="ne-header">Admin</h2>
              </div>
              <div className="ec-box lc-box" style={{ alignItems: "flex-end" }}>
                {!started && (
                  <div className="input-group nassau-group mb-0">
                    <div className="ig-header">
                      <p>Invite Only</p>
                      <GradientInfoIcon
                        className="info-icon"
                        onClick={() => {
                          setDialog(
                            "Choose whether other players can join without being invited"
                          );
                          setShowDialog(true);
                        }}
                      />
                    </div>{" "}
                    <Switch
                      onColor="#1e7a69"
                      checked={inviteOnly}
                      className={
                        inviteOnly
                          ? "scoring-switch switch-on"
                          : "scoring-switch"
                      }
                      onChange={() => setInviteOnly((current) => !current)}
                    />
                  </div>
                )}
                <div className="input-group join-hint">
                  <div className="ig-header">
                    <p>Joining Code</p>
                    <ContentCopyIcon
                      onClick={() => {
                        navigator.clipboard.writeText(joinCode);
                        setShowSnack(true);
                      }}
                      className="mb-10 info-icon"
                    />
                    <button className="green-link" onClick={makeID}>
                      Generate
                    </button>
                  </div>
                  <input
                    onChange={(e) => setJoinCode(e.target.value)}
                    type={"text"}
                    value={joinCode}
                    placeholder="Enter join code..."
                  />
                </div>
                {false && (
                  <div className="input-group admin-hint mb-0">
                    <p>Add Admins</p>
                    <Dropdown
                      arrowClosed={
                        <KeyboardArrowDownIcon className="drop-icon" />
                      }
                      arrowOpen={<KeyboardArrowUpIcon className="drop-icon" />}
                      options={adminOptions}
                      onChange={(e) => {
                        const player = adminOptions.find(
                          (obj) => obj.value === e.value
                        );

                        setAdmins((current) => [...current, player]);
                        setAdminOptions((current) =>
                          current.filter((obj) => obj.value !== e.value)
                        );
                      }}
                    />
                  </div>
                )}
                <div className="input-group pp-hint">
                  <div className="ig-header">
                    <p>Public / Private</p>

                    <GradientInfoIcon
                      className="info-icon"
                      onClick={() => {
                        setDialog(
                          "Choose whether your tournament shows up in searches"
                        );
                        setShowDialog(true);
                      }}
                    />
                  </div>
                  <Dropdown
                    arrowClosed={
                      <KeyboardArrowDownIcon className="drop-icon" />
                    }
                    arrowOpen={<KeyboardArrowUpIcon className="drop-icon" />}
                    value={type}
                    options={publicOptions}
                    onChange={(e) => {
                      setType(e.value);
                    }}
                  />
                </div>
              </div>
              {false && (
                <div className="ec-box lc-box">
                  {!edit && (
                    <>
                      <div className="input-group">
                        <div className="ig-header">
                          <p>Invite Players</p>
                          <button className="green-link" onClick={selectAll}>
                            Select All
                          </button>
                        </div>
                        <Dropdown
                          arrowClosed={
                            <KeyboardArrowDownIcon className="drop-icon" />
                          }
                          arrowOpen={
                            <KeyboardArrowUpIcon className="drop-icon" />
                          }
                          options={inviteable}
                          onChange={(e) => {
                            const player = players.find(
                              (obj) => obj.value === e.value
                            );

                            setSelectedPlayers((current) => [
                              ...current,
                              player,
                            ]);
                            setPlayers((current) =>
                              current.filter((obj) => obj.value !== e.value)
                            );
                          }}
                        />
                      </div>
                      <div className="part-players-box">
                        {selectedPlayers.map((player) => (
                          <div className="ec-pi">
                            <PlayerItem
                              key={player.playerID}
                              hcp={player.handicap}
                              name={player.label}
                              playerID={player.playerID}
                              showAdd
                              hideEdit
                              hideProfile
                              img={player.profileImage}
                            />
                            {false && (
                              <GradientRemoveCircleIcon
                                onClick={() => {
                                  setSelectedPlayers((current) =>
                                    current.filter(
                                      (item) => item.value !== player.value
                                    )
                                  );
                                  setPlayers((current) => [...current, player]);
                                }}
                                className="rci"
                              />
                            )}
                          </div>
                        ))}
                      </div>
                    </>
                  )}
                  {false && (
                    <>
                      <div className="input-group">
                        <div className="ig-header">
                          <p>Members ({members.length})</p>
                        </div>
                      </div>
                      {members.length === 0 && (
                        <div className="no-players mb-20 mt-10">
                          <p>No players have joined this tournament yet</p>
                        </div>
                      )}
                      {members.length > 0 && (
                        <div className="part-players-box">
                          {members.map((player) => (
                            <div className="ec-pi">
                              <PlayerItem
                                key={player.playerID}
                                hcp={player.handicap}
                                name={player.label}
                                playerID={player.playerID}
                                showAdd
                                hideEdit
                                hideProfile
                                img={player.profileImage}
                                removeAction={() => {
                                  setSelectedPlayers((current) =>
                                    current.filter(
                                      (item) => item.value !== player.value
                                    )
                                  );
                                  setPlayers((current) => [...current, player]);
                                }}
                              />
                              {false && (
                                <GradientRemoveCircleIcon
                                  onClick={() => {
                                    setSelectedPlayers((current) =>
                                      current.filter(
                                        (item) => item.value !== player.value
                                      )
                                    );
                                    setPlayers((current) => [
                                      ...current,
                                      player,
                                    ]);
                                  }}
                                  className="rci"
                                />
                              )}
                            </div>
                          ))}
                        </div>
                      )}
                      {!started && (
                        <>
                          <div className="input-group">
                            <div className="ig-header">
                              <p>Invite Players</p>
                              <button
                                className="green-link"
                                onClick={selectAll}
                              >
                                Select All
                              </button>
                            </div>
                            <Dropdown
                              arrowClosed={
                                <KeyboardArrowDownIcon className="drop-icon" />
                              }
                              arrowOpen={
                                <KeyboardArrowUpIcon className="drop-icon" />
                              }
                              options={inviteable}
                              onChange={(e) => {
                                const player = players.find(
                                  (obj) => obj.value === e.value
                                );

                                setSelectedPlayers((current) => [
                                  ...current,
                                  player,
                                ]);
                                setPlayers((current) =>
                                  current.filter((obj) => obj.value !== e.value)
                                );
                              }}
                            />
                          </div>
                          <div className="part-players-box">
                            {selectedPlayers.map((player) => (
                              <div className="ec-pi">
                                <PlayerItem
                                  key={player.playerID}
                                  hcp={player.handicap}
                                  name={player.label}
                                  img={player.profileImage}
                                  showAdd
                                  hideProfile
                                />
                                {false && (
                                  <GradientRemoveCircleIcon
                                    onClick={() => {
                                      setSelectedPlayers((current) =>
                                        current.filter(
                                          (item) => item.value !== player.value
                                        )
                                      );
                                      setPlayers((current) => [
                                        ...current,
                                        player,
                                      ]);
                                    }}
                                    className="rci"
                                  />
                                )}
                              </div>
                            ))}
                          </div>
                        </>
                      )}
                    </>
                  )}
                </div>
              )}
            </>
          )}

          {error !== "" && (
            <div className="error-message-row">
              <p>{error}</p>
            </div>
          )}
          <div style={{ marginBottom: "20px" }} className="flex-center">
            {!edit ? (
              <button className="default-button" onClick={saveTournament}>
                Create Tournament
              </button>
            ) : (
              <button className="default-button" onClick={saveChanges}>
                Save Changes
              </button>
            )}
          </div>
        </>
      )}
    </div>
  );
}

export default MatchPlayTournamentEditor;
